// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/core-js/library/modules/_enum-bug-keys.js
// module id = 344
// module chunks = 0